import { render, staticRenderFns } from "./AquisicaoCredito.vue?vue&type=template&id=ab6cd48e&scoped=true&"
import script from "./AquisicaoCredito.vue?vue&type=script&lang=js&"
export * from "./AquisicaoCredito.vue?vue&type=script&lang=js&"
import style0 from "./AquisicaoCredito.vue?vue&type=style&index=0&id=ab6cd48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6cd48e",
  null
  
)

export default component.exports